import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import PaperComponent from "components/paper/PaperComponent"; // paper

import client from "assets/js/commonApi";
// import { useParams } from "react-router-dom";

import FolderItem from "views/temp/storageManagement/FolderItemUnMenu";
import FileItem from "views/temp/storageManagement/FileItemUnMenu";
import { ListItem, ListItemText, Grid } from "@mui/material";

const Directory = ({
  storage,
  // selectFolder,
  fileExt = [],
  selectFile,
  // onCreateFolderClick,
  onDeleteStorageFolderClick,
  // onUploadStorageFilePopupClick,
  onFolderClick,
  onFolderMoveClick,
  onFileClick,
  onFileMoveClick,
  onFileInfoClick,
  onFileDownloadClick,
  // onUploadStorageFileChange,
  onMoveStorageFile,
  onDeleteStorageFileClick,
}) => {
  // const { storage_sub_id, folder_id } = useParams();

  return (
    <div
      style={{
        width: "100%",
        height: "90%",
        overflow: "auto",
      }}
    >
      <ListItem>
        <ListItemText>
          <Typography sx={{ fontWeight: "bold" }}>폴더</Typography>
        </ListItemText>
      </ListItem>
      <Grid container>
        {storage?.folder_info.map((folder) => (
          <Grid item xs={12} md={6} key={folder.folder_id}>
            <FolderItem
              storage={storage}
              folder={folder}
              onFolderClick={onFolderClick}
              onFolderMoveClick={onFolderMoveClick}
              onDeleteStorageFolderClick={onDeleteStorageFolderClick}
            />
          </Grid>
        ))}
      </Grid>
      <ListItem>
        <ListItemText>
          <Typography sx={{ fontWeight: "bold" }}>파일</Typography>
        </ListItemText>
      </ListItem>
      <Grid container spacing={1}>
        {storage?.file_info
          .filter((file) => {
            return (
              !fileExt ||
              fileExt.length === 0 ||
              fileExt.some(
                (ext) => ext.toLowerCase() === file.file_ext?.toLowerCase(),
              )
            );
          })
          .map((file) => (
            <Grid item xs={12} md={6} key={file.upload_file_id}>
              <FileItem
                storage={storage}
                file={file}
                select={selectFile?.some(
                  (item) => item.upload_file_id === file.upload_file_id,
                )}
                onFileClick={onFileClick}
                onFileInfoClick={onFileInfoClick}
                onFileMoveClick={onFileMoveClick}
                onFileDownloadClick={onFileDownloadClick}
                onMoveStorageFile={onMoveStorageFile}
                onDeleteStorageFileClick={onDeleteStorageFileClick}
              />
            </Grid>
          ))}
      </Grid>
    </div>
  );
};

function ModalFileExplorer({
  group,
  isOpen,
  fileData = [],
  fileExt,
  onClose,
  onSelect,
}) {
  const [storageDirectory, setStorageDirectory] = useState();
  const [path, setPath] = useState("/root");
  const [selectFolder, setSelectFolder] = useState();
  const [selectFiles, setSelectFiles] = useState([]);

  const getDirectory = useCallback(
    (_folder) => {
      if (!group?.storage_sub_id) {
        return;
      }

      if (_folder) {
        if (_folder.folder_id === "root") {
          // root인 경우
          client
            .post("/storage/root", { storage_sub_id: group.storage_sub_id })
            .then((res) => {
              const data = res?.data.data;
              const storage_sub_id = group.storage_sub_id;
              const folder_info = data.folder_info ?? [];
              const file_info =
                data.file_info.map((f) => ({
                  ...f,
                  storage_sub_id: storage_sub_id,
                })) ?? [];

              setStorageDirectory({ storage_sub_id, folder_info, file_info });
            });
        } else {
          client
            .post("/folder/detail", {
              folder_id: _folder?.folder_id,
            })
            .then((res) => {
              const data = res?.data.data;
              const storage_sub_id = group.storage_sub_id;
              const folder_info = data.folder_info ?? [];
              const file_info =
                data.file_info.map((f) => ({
                  ...f,
                  folder_id: _folder?.folder_id,
                  storage_sub_id: storage_sub_id,
                })) ?? [];

              setStorageDirectory({ storage_sub_id, folder_info, file_info });
            });
        }

        return;
      }

      // 해당 folder에서 디렉토리 조회하기
      if (!selectFolder || selectFolder.folder_id === "root") {
        // root인 경우
        client
          .post("/storage/root", { storage_sub_id: group.storage_sub_id })
          .then((res) => {
            const data = res?.data.data;
            const storage_sub_id = group.storage_sub_id;
            const folder_info = data.folder_info ?? [];
            const file_info = data.file_info ?? [];

            setStorageDirectory({ storage_sub_id, folder_info, file_info });
          });
      } else {
        client
          .post("/folder/detail", {
            folder_id: selectFolder.folder_id,
          })
          .then((res) => {
            const data = res?.data.data;
            const storage_sub_id = group.storage_sub_id;
            const folder_info = data.folder_info ?? [];
            const file_info = data.file_info ?? [];

            setStorageDirectory({ storage_sub_id, folder_info, file_info });
          });
      }
      // 해당 folder에서 디렉토리 조회하기
    },
    [selectFolder, group],
  );

  const onMoveParentFolderClick = () => {
    const folderInfo = selectFolder;
    if (folderInfo) {
      if (folderInfo.parent_folder_id) {
        setSelectFolder({ folder_id: folderInfo.parent_folder_id });
        getDirectory({ folder_id: folderInfo.parent_folder_id });
        setPath((pre) => {
          return pre.split("/").pop().join("/");
        });
        return;
      }
    }

    setSelectFolder();
    setPath("/root");
    getDirectory({ folder_id: "root" });
  };

  useEffect(() => {
    if (fileData) {
      console.log("[fileData]", fileData);
      setSelectFiles(fileData);
    }
  }, [fileData]);

  useEffect(() => {
    if (isOpen && group) {
      setSelectFolder();
      setPath("/root");
      getDirectory({ folder_id: "root" });
    }
  }, [isOpen, group]);

  return (
    <Box sx={{ flexGrow: 1, overflow: "hidden", px: 3 }}>
      <Dialog
        open={isOpen}
        onClose={() => {
          onClose();
        }}
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          component="h1"
          variant="h6"
          style={{ cursor: "move" }}
          id="draggable-dialog-title"
        >
          파일 매핑 탐색기
        </DialogTitle>
        <DialogContent sx={{ width: "600px" }}>
          <Typography variant="subtitle2" color={"#007bff"} align="right">
            {"파란색 파일은 매핑된 파일입니다"}
          </Typography>
          <Typography variant="subtitle2">{`${path}`}</Typography>
          <Directory
            storage={storageDirectory}
            selectFile={selectFiles}
            fileExt={fileExt}
            onFolderClick={(folder) => () => {
              setSelectFolder(folder);
              getDirectory(folder);
              setPath((pre) => `${pre}/${folder.folder_name}`);
            }}
            onFileClick={(file) => () => {
              setSelectFiles((pre) => {
                if (
                  pre.some(
                    (item) => item.upload_file_id === file.upload_file_id,
                  )
                ) {
                  return pre.filter(
                    (item) => item.upload_file_id !== file.upload_file_id,
                  );
                } else {
                  return [...pre, file];
                }
              });
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onMoveParentFolderClick}
            variant="contained"
            sx={{
              marginLeft: "15px",
              height: "41px",
              boxShadow: "none",
              backgroundColor: "#29304a",
            }}
          >
            상위이동
          </Button>
          <Button
            onClick={() => {
              onSelect(selectFiles);
              onClose();
            }}
            variant="contained"
            sx={{
              marginLeft: "15px",
              height: "41px",
              boxShadow: "none",
              backgroundColor: "#29304a",
            }}
          >
            선택
          </Button>
          <Button
            onClick={() => {
              onClose();
            }}
            variant="contained"
            sx={{
              marginLeft: "15px",
              height: "41px",
              boxShadow: "none",
              backgroundColor: "#29304a",
            }}
          >
            닫기
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default ModalFileExplorer;
